module.exports = __webpack_public_path__ + "static/media/close-gif.383845bf.gif";